import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { computed } from "vue";
import CmsSmartCallout from "./cms-smart-callout.vue";
import CmsSmartTextBox from "./cms-smart-text-box.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-text-renderer',
  props: {
    html: {}
  },
  setup(__props: any) {

/* eslint-disable */
const props = __props;

// break down html
let regex = /(<\/?CmsSmartCallout>|<\/?CmsSmartTextBox>)/g;
const fragments = computed(() => {
  let parts = props.html.split(regex);
  let type = "";
  let fragmentArray = [] as { type: string; content: string }[];
  for (let i = 0; i < parts.length; i++) {
    if (regex.test(parts[i])) {
      if (parts[i].startsWith("</")) {
        type = "";
      } else {
        type = parts[i].replace("<", "").replace(">", "");
      }
    } else {
      fragmentArray.push({ type, content: parts[i] });
    }
  }

  return fragmentArray;
});

return (_ctx: any,_cache: any) => {
  return (fragments.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fragments.value, (fragment, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (!fragment.type)
              ? (_openBlock(), _createElementBlock("span", {
                  innerHTML: fragment.content,
                  key: index
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true),
            (fragment.type === 'CmsSmartCallout')
              ? (_openBlock(), _createBlock(CmsSmartCallout, {
                  key: index,
                  uid: fragment.content
                }, null, 8, ["uid"]))
              : _createCommentVNode("", true),
            (fragment.type === 'CmsSmartTextBox')
              ? (_openBlock(), _createBlock(CmsSmartTextBox, {
                  key: index,
                  uid: fragment.content
                }, null, 8, ["uid"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        innerHTML: _ctx.html
      }, null, 8, _hoisted_3))
}
}

})